import React, { useEffect, useState } from "react";
import ReusableTable from "../components/ReusableTable";
import { getApiUrl } from "../utils/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Samplecollection = () => {
  const UserId = "66abc123def4567890abcd12";

  const [list, setList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);

  // TEXTS
  const [advertisementTexts, setAdvertisementTexts] = useState([""]);
  const [sampleTexts, setSampleTexts] = useState([""]);

  // IMAGES
  const [homeImages, setHomeImages] = useState([]);
  const [adImages, setAdImages] = useState([]);
  const [sampleImages, setSampleImages] = useState([]);

  /* ================= FETCH BANNERS ================= */
  const fetchBanners = async () => {
    try {
      const res = await fetch(getApiUrl("banner-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      const result = await res.json();
      if (result.success) setList(result.data);
      else toast.error(result.message || "Failed to fetch");
    } catch (err) {
      toast.error("Server error");
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  /* ================= RESET FORM ================= */
  const resetForm = () => {
    setEditId(null);
    setAdvertisementTexts([""]);
    setSampleTexts([""]);
    setHomeImages([]);
    setAdImages([]);
    setSampleImages([]);
  };

  /* ================= OPEN EDIT MODAL ================= */
  const openEditModal = (row) => {
    setEditId(row._id);
    setAdvertisementTexts(
      row.advertisementDescription.length ? row.advertisementDescription : [""]
    );
    setSampleTexts(row.sampleDescription.length ? row.sampleDescription : [""]);
    setHomeImages([]); // Clear new uploads for editing
    setAdImages([]);
    setSampleImages([]);
    setShowModal(true);
  };

  /* ================= HANDLE SAVE / UPDATE ================= */
  const handleSave = async () => {
    if (
      !advertisementTexts.filter(Boolean).length &&
      !sampleTexts.filter(Boolean).length &&
      homeImages.length === 0 &&
      adImages.length === 0 &&
      sampleImages.length === 0
    ) {
      toast.error("Enter at least one text or image");
      return;
    }

    const formData = new FormData();
    formData.append("userId", UserId);
    if (editId) formData.append("bannerId", editId);

    advertisementTexts.filter(Boolean).forEach((text) =>
      formData.append("advertisementDescription", text)
    );
    sampleTexts.filter(Boolean).forEach((text) =>
      formData.append("sampleDescription", text)
    );

    homeImages.forEach((file) => formData.append("homeBanner", file));
    adImages.forEach((file) => formData.append("advertisementBanner", file));
    sampleImages.forEach((file) => formData.append("sampleBanner", file));

    const url = editId ? getApiUrl("banner-update") : getApiUrl("banner-create");

    try {
      const res = await fetch(url, { method: "POST", body: formData });
      const result = await res.json();
      if (result.success) {
        toast.success(editId ? "Updated successfully" : "Added successfully");
        setShowModal(false);
        resetForm();
        fetchBanners();
      } else toast.error(result.message);
    } catch (err) {
      toast.error("Server error");
      console.error(err);
    }
  };

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure?")) return;

    try {
      const res = await fetch(getApiUrl("banner-delete"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ bannerId: id }),
      });
      const result = await res.json();
      if (result.success) {
        toast.success("Deleted successfully");
        fetchBanners();
      } else toast.error(result.message);
    } catch {
      toast.error("Server error");
    }
  };

  /* ================= HANDLE MULTIPLE TEXTS ================= */
  const handleTextChange = (setter, idx, value) => {
    setter((prev) => prev.map((t, i) => (i === idx ? value : t)));
  };
  const handleAddText = (setter) => {
    setter((prev) => [...prev, ""]);
  };
  const handleRemoveText = (setter, idx) => {
    setter((prev) => prev.filter((_, i) => i !== idx));
  };

  /* ================= TABLE COLUMNS ================= */
  const columns = [
    { name: "Advertisement Text", selector: (row) => row.advertisementDescription?.join(", ") },
    { name: "Sample Text", selector: (row) => row.sampleDescription?.join(", ") },
    {
      name: "Images",
      selector: (row) => (
        <>
          {row.homeBanner?.map((img, idx) => (
            <img key={idx} src={img} alt="home" width={50} style={{ marginRight: 5 }} />
          ))}
          {row.advertisementBanner?.map((img, idx) => (
            <img key={idx} src={img} alt="ad" width={50} style={{ marginRight: 5 }} />
          ))}
          {row.sampleBanner?.map((img, idx) => (
            <img key={idx} src={img} alt="sample" width={50} style={{ marginRight: 5 }} />
          ))}
        </>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <button className="btn btn-warning btn-sm me-2" onClick={() => openEditModal(row)}>Edit</button>
          <button className="btn btn-danger btn-sm" onClick={() => handleDelete(row._id)}>Delete</button>
        </>
      ),
    },
  ];

  /* ================= IMAGE UPLOAD UI HELPER ================= */
  const ImageUpload = ({ label, files, setFiles }) => (
    <div className="mb-3">
      <label className="form-label fw-bold">{label}</label>
      <div className="d-flex flex-wrap mb-2">
        {files.map((file, idx) => (
          <div key={idx} style={{ position: "relative", marginRight: 10, marginBottom: 10 }}>
            <img
              src={URL.createObjectURL(file)}
              alt={label}
              width={80}
              height={80}
              style={{ objectFit: "cover", borderRadius: 5 }}
            />
            <button
              type="button"
              onClick={() => setFiles(files.filter((_, i) => i !== idx))}
              style={{
                position: "absolute",
                top: -5,
                right: -5,
                background: "red",
                border: "none",
                borderRadius: "50%",
                color: "white",
                width: 20,
                height: 20,
                cursor: "pointer",
              }}
            >
              ×
            </button>
          </div>
        ))}
      </div>
      <input
        type="file"
        multiple
        onChange={(e) => setFiles([...files, ...Array.from(e.target.files)])}
      />
    </div>
  );

  return (
    <div className="container mt-4">
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="fw-bold">Banner Management</h3>
        <button className="btn btn-primary" onClick={() => { resetForm(); setShowModal(true); }}>+ Add Banner</button>
      </div>

      <ReusableTable columns={columns} data={list} />

      {/* MODAL */}
      {showModal && (
        <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content rounded-3">
              <div className="modal-header">
                <h5 className="modal-title">{editId ? "Edit Banner" : "Add Banner"}</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                {/* Advertisement Texts */}
                <div className="mb-3">
                  <label className="form-label fw-bold">Advertisement Texts</label>
                  {advertisementTexts.map((text, idx) => (
                    <div key={idx} className="d-flex mb-2">
                      <input
                        type="text"
                        className="form-control me-2"
                        value={text}
                        onChange={(e) => handleTextChange(setAdvertisementTexts, idx, e.target.value)}
                      />
                      <button className="btn btn-danger" onClick={() => handleRemoveText(setAdvertisementTexts, idx)}>X</button>
                    </div>
                  ))}
                  <button className="btn btn-sm btn-secondary" onClick={() => handleAddText(setAdvertisementTexts)}>+ Add Text</button>
                </div>
                <div className="mb-3">
                  <label className="form-label fw-bold">Sample Texts</label>
                  {sampleTexts.map((text, idx) => (
                    <div key={idx} className="d-flex mb-2">
                      <input
                        type="text"
                        className="form-control me-2"
                        value={text}
                        onChange={(e) => handleTextChange(setSampleTexts, idx, e.target.value)}
                      />
                      <button className="btn btn-danger" onClick={() => handleRemoveText(setSampleTexts, idx)}>X</button>
                    </div>
                  ))}
                  <button className="btn btn-sm btn-secondary" onClick={() => handleAddText(setSampleTexts)}>+ Add Text</button>
                </div>

                <ImageUpload label="Home Banner Images" files={homeImages} setFiles={setHomeImages} />
                <ImageUpload label="Advertisement Banner Images" files={adImages} setFiles={setAdImages} />
                <ImageUpload label="Sample Banner Images" files={sampleImages} setFiles={setSampleImages} />
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                <button className="btn btn-success" onClick={handleSave}>{editId ? "Update" : "Save"}</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Samplecollection;
